import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pipe from 'lodash/fp/pipe';
import curry from 'lodash/fp/curry';
import styled from 'styled-components';

import { DEFAULT_ERRORS_COLOR } from 'common/entities/form/styleConfiguration/defaultValues';
import { getFormErrorStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getFormRendererFormId } from '../../../selectors';

const Label = styled.span`
    color: ${(props) => props.color};
`;

const RequiredAsterisk = ({ errorColor }) => (
    <Label className="FormNode__question--required" color={errorColor}>
        *
    </Label>
);

RequiredAsterisk.propTypes = {
    errorColor: PropTypes.string,
};
RequiredAsterisk.defaultProps = {
    errorColor: DEFAULT_ERRORS_COLOR,
};

const mapStateToProps = (state, props) => ({
    errorColor: pipe(
        getFormRendererFormId,
        curry(getFormErrorStyles)(state),
        ({ color }) => color && color.value,
    )(state),
});

export const RequiredAsteriskStandalone = RequiredAsterisk;
export default connect(mapStateToProps, undefined)(RequiredAsterisk);
